import React from 'react'
import IconChevronLeft from '@/components/IconChevronLeft'
import IconChevronRight from '@/components/IconChevronRight'

interface CarouselArrowProps {
  size: 'md' | 'lg'
  direction: 'left' | 'right'
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
  removeBorderOffset?: boolean
}

const CarouselArrow: React.FC<CarouselArrowProps> = ({
  size,
  direction,
  onClick,
  removeBorderOffset
}) => {
  const divSize = size === 'md' ? 'size-9' : 'size-11'
  const isRight = direction === 'right'
  const icon = isRight ? (
    <IconChevronRight size="md" />
  ) : (
    <IconChevronLeft size="md" />
  )
  const positionClass = removeBorderOffset ? '' : isRight ? 'right-8' : 'left-8'

  return (
    <div
      className={`absolute hidden md:flex ${positionClass} ${divSize} active:shadow-none top-1/2 z-[5] mb-0.5 flex shrink-0
        -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-gray-400 bg-white 
        px-1 py-2 shadow-[0_6px_16px_-3px_rgba(0,0,0,0.25),0_4_6px_-4px_rgba(0,0,0,0.10)]
      hover:bg-gray-50 active:bg-gray-200`}
      onClick={onClick}
    >
      {icon}
    </div>
  )
}

export default CarouselArrow
